export default __webpack_public_path__ + "static/media/wind-turbine-existing-icon.a20b190e.svg";